const AUTO_ADVANCE_SPEED = 12; // time in seconds

export default {
  props: {
    vertical: { type: Boolean, default: false },
    heroHorizontal: { type: Boolean, default: false },
    itemCount: { type: Number, required: true },
    currentIndex: { type: Number, required: true },
    autoAdvance: { type: Boolean, default: false },
    prizesVersion: { type: Boolean, default: false }, // If this is the prizes section version of the carousel
  },
  data() {
    return {
      initialTime: null,
      progressPercentage: 0,
      interval: null,
    };
  },
  computed: {
    /**
     * string for the total number of items
     *
     * @returns {String}
     */
    lastIndexString() {
      return `0${this.itemCount}`;
    },

    /**
     * The index of the next slide
     *
     *
     * @returns {Number}
     */
    nextIndex() {
      let next = this.currentIndex + 1;

      if (next > this.itemCount - 1) {
        // only loop
        next = 0;
      }
      return next;
    },

    /**
     * string for the next index
     *
     * @returns {String}
     */
    nextIndexString() {
      return `0${this.nextIndex + 1}`;
    },

    /**
     * string for the current index
     *
     * @returns {String}
     */
    indexString() {
      if (this.vertical) {
        return '01';
      }
      return `0${this.currentIndex + 1}`;
    },

    /**
     * string  at the end of the progress bar
     *
     * @returns {String}
     */
    progressDestinationString() {
      if (this.prizesVersion) {
        return this.nextIndexString;
      }
      return this.lastIndexString;
    },
    /**
     * background animation transition
     *
     * @returns {Object}
     */
    percentageStyle() {
      const transformDirection = !this.vertical ? 'translateX' : 'translateY';
      return {
        transform: `${transformDirection}(${-100 + ((this.progressPercentage) * 100)}%)`,
      };
    },
    /**
     * icons for the next and prev buttons
     *
     * @returns {Object}
     */
    buttonIcons() {
      let prev = 'chevron_left';
      let next = 'chevron_right';
      if (this.vertical) {
        prev = 'expand_less';
        next = 'expand_more';
      }
      return {
        prev,
        next
      };
    }
  },
  methods: {
    /**
     * update the progress animate background and increment prize carousel
     */
    updateProgressPercentage() {
      const currentTime = new Date().getTime();
      this.progressPercentage = (((currentTime - this.initialTime) / 1000) / AUTO_ADVANCE_SPEED);
      if (this.progressPercentage > 1) {
        this.$emit('slideChange', 'next');
        this.restart();
      } else {
        this.requestAnimation = window.requestAnimationFrame(this.updateProgressPercentage);
      }
    },
    /**
     * handle a next or prev click
     *
     * @param {String} direction - prev or next
     */
    handleClick(direction) {
      this.$emit('slideChange', direction);
      if (this.autoAdvance) {
        // true for the prize section
        clearInterval(this.interval);
        window.cancelAnimationFrame(this.requestAnimation);
        this.restart();
      } else if (this.progressPercentage === 1) {
        this.progressPercentage = 0.5;
      } else {
        this.progressPercentage = 1;
      }
    },
    /**
     * restart the progress bar animation
     */
    restart() {
      this.progressPercentage = 0;
      window.cancelAnimationFrame(this.requestAnimation);
      this.timeout = setTimeout(() => {
        this.initialTime = new Date().getTime();
        this.requestAnimation = window.requestAnimationFrame(this.updateProgressPercentage);
      }, 600);
    },
  },
  mounted() {
    this.initialTime = new Date().getTime();
    if (this.vertical) {
      this.progressPercentage = 0.5;
    }
  },
  beforeDestroy() {
    window.clearTimeout(this.timeout);
  },
  watch: {
    autoAdvance: {
      immediate: true,
      handler(value) {
        if (value) {
          this.updateProgressPercentage();
        }
      }
    },
    currentIndex() {
      if (this.prizesVersion) {
        this.restart();
      }
    },
  }
};
